import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomedashboardComponent, SafetyboxComponent, BrowserequestComponent, ProfileComponent, ManageProjectsComponent } from './index';
import { AuthGuardService, RoleGuardService } from '../authentication/service/auth-guard.service';

const routes: Routes = [
      { path: 'seller',
      component: HomedashboardComponent,
      canActivate: [AuthGuardService]
    },
    {
      path: 'seller/profile',
      component: ProfileComponent,
      canActivate: [RoleGuardService],
      data: {
        expectedRole: ['seller']
      }
    },
    {
    path: 'seller/safetybox',
    component: SafetyboxComponent,
    canActivate: [RoleGuardService],
    data: {
      expectedRole: ['seller']
    }
    },
    {
    path: 'seller/browserequest',
    component: BrowserequestComponent,
    canActivate: [RoleGuardService],
    data: {
      expectedRole: ['seller']
    }
    },
    {
        path: 'seller/manageprojects',
        component: ManageProjectsComponent,
        canActivate: [RoleGuardService],
        data: {
          expectedRole: ['seller']
        }
    }
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SellerRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/seller/seller-routing.module.ts